<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('closeModal')" />
    <div class="modal">
      <div class="title-close">
        <h1 class="modal-title">{{ adminText('organizationAll.invite_new_members_1b068b84', 'Invite new members') }}</h1>
        <span class="material-icons close-icon" @click="$emit('closeModal')"> close </span>
      </div>
      <p class="modal-subtitle">
        {{ adminText('organizationAll.use_the_link_below_to_invite_people_to_join_y_ef96b782', 'Use the link below to invite people to join your community. Just share it and they can fill out the membership form.') }}
      </p>
      <copy-link prepend-icon="link" :link="inviteUrl" />
    </div>
  </div>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import CopyLink from '@/components/shared/copy-link.vue'

export default {
  mixins: [OrganizationLocalization],
  name: 'invite-link-modal',
  components: {
    CopyLink,
  },
  params: {
    membershipPlanId: String,
  },
  data() {
    const { organizationSlug, membershipPlanId } = this.$route.params
    const baseUrl = process.env.VUE_APP_FRONTEND_URL || window.location.origin

    return {
      inviteUrl: `${baseUrl}/membership-form/${organizationSlug}/membership-registration?membershipPlanId=${membershipPlanId}&lang=hr`,
    }
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 20px;
  z-index: 999;
}

.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}

.modal {
  text-align: left;
  background-color: #ffffff;
  width: 100%;
  max-width: 48rem;
  border-radius: 1.25rem;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 2rem 2.5rem;
}

.modal::-webkit-scrollbar {
  display: none;
}

.title-close {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
  margin: 0;
}

.close-icon {
  cursor: pointer;
}

.modal-subtitle {
  margin: 0;
  color: #979797;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
  }
}
</style>
